import React from 'react';
import { Box, Flex } from '@goodrx/matisse-react';
import { ComponentRenderer } from '@goodrx/x-core';
export const SpacedColumns = ({
  componentMap,
  className,
  linksCollection
}) => {
  const items = (linksCollection === null || linksCollection === void 0 ? void 0 : linksCollection.items.filter(item => !!item)) || [];
  const width = `${100 / items.length}%`;
  return /*#__PURE__*/React.createElement(Flex, {
    className: className,
    justifyContent: "space-around",
    alignItems: "center",
    flexWrap: "wrap",
    py: 4
  }, items.map(data => /*#__PURE__*/React.createElement(Box, {
    width: {
      _: '33%',
      md: width
    },
    textAlign: "center",
    key: data.sys.id
  }, /*#__PURE__*/React.createElement(ComponentRenderer, {
    data: { ...data,
      width
    },
    componentMap: componentMap
  }))));
};